module.exports = __webpack_public_path__ + "img/Icon_box_close.56f399f6.svg";